
/**
 * Internal dependencies
 */
import {
    KIOSK_PLANS_RECEIVE,
    KIOSK_PLANS_REQUEST,
    KIOSK_PLANS_REQUEST_SUCCESS,
    KIOSK_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { getAllKioskPlans, requestingKioskPlans } from './selectors';

/**
 * [description]
 * 
 * @param  {Function}   [description]
 * @return {[type]}                  [description]
 */
export const requestKioskPlans = () => (dispatch) => {
    dispatch({
        type: KIOSK_PLANS_REQUEST
    });

    return cscom.kioskPlan().list()
        .then(kioskPlans => {
            dispatch({
                type: KIOSK_PLANS_REQUEST_SUCCESS
            });
            dispatch({
                type: KIOSK_PLANS_RECEIVE,
                payload: {
                    items: kioskPlans
                }
            });
            return kioskPlans
        }); 
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllKioskPlans(getState());
	const requesting = requestingKioskPlans(getState());

	if (plans.length === 0 && requesting === false) {
		return dispatch(requestKioskPlans(...props))
	}

	return plans;
}